import { useMemo } from 'react';

// import { useMergedRef } from '@/hook';

import { VTable } from '../VTable';
import { DEFAULT_RENDER_CELL } from './constant';
import {
  // useFileBrowserContentDragboxContext,
  useFileBrowserContext,
} from './context';

const VFileBrowserContentList = () => {
  const {
    contentItemNodeList,
    currentDir,
    eventEmitter,
    emptyRenderer,
    itemByUuid,
    loadingContent,
    loadingContentRenderer,
    selectedItemUuidList,
    setCurrentDirUuid,
  } = useFileBrowserContext();
  // const { $dragboxParent } = useFileBrowserContentDragboxContext();
  // const mergedRef = useMergedRef($dragboxParent);

  const parentDir = useMemo(() => {
    const entryList = Object.entries(itemByUuid);
    const parent = entryList.find(([_, item]) =>
      item.children?.find(childItem => childItem.uuid === currentDir?.uuid),
    );

    return parent?.[1];
  }, [currentDir, itemByUuid]);
  const renderedList = useMemo(() => {
    const renderedList = contentItemNodeList.list.map(i => ({
      name: i.value.name,
      size: i.value.size,
      lastUpdated: i.value.updatedAt,
      remove: null,

      id: i.value.uuid,
      isDir: i.value.isDir,
    }));

    return (
      parentDir
        ? [
            {
              name: '..',
              size: parentDir.size,
              lastModified: parentDir.updatedAt,
              remove: null,

              id: parentDir.uuid,
              isDir: true,
            },
          ]
        : []
    ).concat(renderedList as any);
  }, [contentItemNodeList.list, parentDir]);

  return (
    <VTable
      // ref={mergedRef as React.Ref<HTMLDivElement>}
      className="h-full"
      columnStyleMap={{
        size: {
          style: {
            width: '132px',
          },
        },
        lastModified: {
          style: {
            width: '174px',
          },
        },
        remove: {
          style: {
            width: '68px',
          },
        },
      }}
      setRowRemovable={({ name }) => (name === '..' ? false : true)}
      setRowSelected={() => true}
      setRowActivated={({ id }) => selectedItemUuidList.includes(id)}
      columnList={['name', 'size', 'lastModified', 'remove']}
      data={renderedList}
      cellRenderer={{
        name: (value, _, { isDir }) => DEFAULT_RENDER_CELL.name(value, isDir),
        size: (value, _, { isDir }) =>
          isDir ? '' : DEFAULT_RENDER_CELL.size(value ?? 0),
        lastModified: value =>
          DEFAULT_RENDER_CELL.lastModified(value as DateLike),
      }}
      loading={loadingContent}
      renderEmptyData={emptyRenderer.content}
      renderLoadingData={loadingContentRenderer}
      resizable
      onRowClick={e => {
        if (e.target.row.name === '..') {
          e.preventDefault();

          return;
        }

        const { id } = e.target!.row;

        eventEmitter.emit('itemClick', {
          src: 'content',
          item: itemByUuid[id],
        });
      }}
      onRemove={id => {
        eventEmitter.emit('itemRemove', {
          itemList: [itemByUuid[id]],
        });
      }}
      onDoubleClick={e => {
        const { id, isDir } = e.target!.row;

        isDir && setCurrentDirUuid(id);
        eventEmitter.emit('itemDblClick', { item: itemByUuid[id] });
      }}
      onScrollEnd={() => {
        eventEmitter.emit('endOfDirectory', { item: currentDir! });
      }}
    />
  );
};

export default VFileBrowserContentList;
